import Language from '../../helpers/Language';
import { Stylesheet } from '../../interfaces/Stylesheet';
import { Ticket } from '../../interfaces/Ticket';
import { getBrandColorsUriEncoded } from '../../services/StylesheetService';

const getQuestionsUrl = ({
  globalStylesheet,
  stylesheet,
  ticket
}: {
  globalStylesheet: Stylesheet;
  stylesheet: Stylesheet;
  ticket?: Ticket;
}): string => {
  const hasQuestions = stylesheet?.questionSection && globalStylesheet?.questionSection;

  if (!hasQuestions || !ticket) {
    return '';
  }

  const instanceUrl = `${import.meta.env.VITE_QUESTIONNAIRE_URL}`;
  const lang = `&lang=${Language.getLanguage()}`;
  const workOrderId = `&WorkOrderID=${ticket.workOrder.id}`;
  const workType = `&WorkType=${ticket.workOrder.workTypeId}`;
  const engineFinished = `&Engine_finished=${ticket.workOrder.isQuestionnaireCompleted}`;
  const woStatus = `&WorkOrderStatus=${ticket.workOrder.status}`;
  const desc = `&Description=${ticket.workOrder.name}`;
  const stylesheetUrl = `&stylesheetURL=${import.meta.env.VITE_CDN_BASEURL}/questionary-styles/questionnaire.css`;

  const colors = getBrandColorsUriEncoded(stylesheet);
  const colorsVars = `&primary=${colors.primary}&secondary=${colors.secondary}&background=${colors.background}`;

  return instanceUrl.concat(lang, workOrderId, workType, engineFinished, woStatus, desc, stylesheetUrl, colorsVars);
};

const subscribeWindowMessages = (listener: (event: MessageEvent) => void) => {
  window.addEventListener('message', listener);

  return () => window.removeEventListener('message', listener);
};


export default {
  getQuestionsUrl,
  subscribeWindowMessages,
};
